import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Page4.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { trackNewsletterSignup, trackInstallClick } from "../utils/gtmTracking";

// Assets
import t1 from "../assets/images/t1.png";
import t2 from "../assets/images/t2.png";
import t3 from "../assets/images/t3.png";
import bottomImagePage4 from "../assets/images/Page4_Bottom_Bit@.png";
import SignUpFrame from "../assets/images/Page4_Signup_Frame@.png";
import SubmitButton from "../assets/images/submitBtn.png";
import Sean from "../assets/images/Page4_Sean@.png";
import Margarita from "../assets/images/Page4_Margarita@.png";
import Phil from "../assets/images/Page4_Phil@.png";
import Itzamna from "../assets/images/Page4_Itzamna@.png";
import Icon from "../assets/images/Page4_Spurpunk_icon@.png";
import Page4DottedLine from "../assets/images/Picture1.png";
import AppStore from "../assets/images/AppleStore_BTN@.svg";
import PlayStore from "../assets/images/GooglePlay_BTN@.png";
import Cactus from "../assets/images/map-cactus2-icon_COPY@.png";
import Grass from "../assets/images/Map-grass-icon2@.png";
import Landmass from "../assets/images/Page4_Landmass_COPY@.png";

const Page4 = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [message, setMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("Submitting...");

    const { name, email } = formData;

    // Validate inputs
    if (!name || !email) {
      setMessage("Please fill in both fields.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    // ✅ Immediate feedback to the user
    setMessage("✅ Thank you for subscribing!");
    setFormData({ name: "", email: "" });

    // Prepare both async tasks
    const firestorePromise = addDoc(collection(db, "signups"), {
      name: name.trim(),
      email: email.trim(),
      createdAt: serverTimestamp(),
      source: "Spurpunk",
    });

    const authHeader = "Basic " + btoa("admin_martech" + ":" + "0123406789012");
    const backendPromise = axios.post(
      "https://martech-robotrace-ykgj.onrender.com/submit",
      formData,
      { headers: { Authorization: authHeader } }
    );

    try {
      // ✅ Run Firestore and backend in parallel
      await Promise.allSettled([firestorePromise, backendPromise]);

      trackNewsletterSignup(email, name, true);
    } catch (error) {
      console.error("Error submitting data:", error);
      trackNewsletterSignup(email, name, false);
      setMessage("Oops, something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    console.log("Updated message:", message);
  }, [message]);

  return (
    <div className="container-fluid g-0 d-flex flex-column">
      {/* Header */}
      <div className="topSection row g-0">
        <img src={t1} alt="Testimony Top" className="img-fluid testimony-slice col-12 col-md-4" />
        <img src={t2} alt="Testimony Middle" className="img-fluid testimony-slice col-12 col-md-4" />
        <img src={t3} alt="Testimony Bottom" className="img-fluid testimony-slice col-12 col-md-4" />
      </div>

      {/* Mid Section */}
      <div className="midSection position-relative d-flex justify-content-center align-items-center g-0">
        <img src={Landmass} alt="Landmass" className="p4-landmass" />
        <img src={Page4DottedLine} alt="Page4 Dotted Line" className="img-fluid page4-dotted-line" />
        <img src={Icon} alt="Spurpunk icon" className="img-fluid icon" />
        <img src={Sean} alt="Hero Sean" className="img-fluid sean" />
        <img src={Margarita} alt="Hero Margarita" className="img-fluid margarita" />
        <img src={Phil} alt="Hero Phil" className="img-fluid phil" />
        <img src={Cactus} alt="Cactus" className="img-fluid cactus" />
        <img src={Grass} alt="Grass" className="img-fluid grass" />

        <p className="signup-text">
          Sign up to stay on top of Spurpunk Training
          <br />
          and see which one you might become!
        </p>

        <img src={SignUpFrame} alt="Signup Frame" className="signup-frame" />

        <div className="name-container">
          <label htmlFor="name" className="name-label">NAME</label>
          <input
            type="text"
            id="name"
            name="name"
            className="name-input"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>

        <div className="email-container">
          <label htmlFor="email" className="email-label">E-MAIL</label>
          <input
            type="text"
            id="email"
            name="email"
            className="email-input"
            value={formData.email}
            onChange={handleInputChange}
          />
          <div className="message-container">
            <span className="email-message">{message}</span>
          </div>
        </div>

        <div className="image-button" onClick={handleSubmit}>
          <img src={SubmitButton} alt="Submit Button" className="submit-button" />
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bottomSection">
        <img src={bottomImagePage4} alt="Bottom Section" className="img-fluid bottom-img" />

        <div className="download-btns">
          <a
            href="https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              trackInstallClick(
                "google_play",
                "https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US"
              );
              window.open(
                "https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <img src={PlayStore} alt="Play Store" className="img-fluid playstore" />
          </a>

          <a
            href="https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              trackInstallClick(
                "apple_app_store",
                "https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone"
              );
              window.open(
                "https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <img src={AppStore} alt="App Store" className="img-fluid appstore" />
          </a>
        </div>

        <img src={Itzamna} alt="Itzamna" className="img-fluid itzamna" />
      </div>
    </div>
  );
};

export default Page4;
